import AdvertisableApplication from '@/entities/AdvertisableApplication';
import BaseEntity from '@/entities/BaseEntity';
import Customconversion from '@/entities/Customconversion';
import Pixel from '@/entities/Pixel';
import SourceProfile from '@/entities/SourceProfile';
import User from '@/entities/User';
import { appInstance } from '@/utils/appInstance.js';

export default class AdAccount extends BaseEntity {
  id = null;
  owner = null;
  platform = null;
  external_id = null;
  name = '';
  status = null;
  account_status = '';
  age = 0;
  currency = 'EUR';
  min_daily_budget = null;
  has_payment_method = null;
  spend_cap = null;
  amount_spent = null;
  advertisable_applications = [];
  customconversions = [];
  pixels = [];
  pages = [];
  instagram_accounts = [];
  lost_access = null;
  send_weekly_report = false;
  weekly_report_day = null;
  weekly_report_to = [];
  tos_accepted = false;
  deleted_at = null;

  _entityFields = {
    owner: User,
  };

  _entityArrayFields = {
    advertisable_applications: AdvertisableApplication,
    customconversions: Customconversion,
    pixels: Pixel,
    pages: SourceProfile,
    instagram_accounts: SourceProfile,
    weekly_report_to: User,
  };

  constructor(rawData) {
    super();
    /* if (rawData?.deleted_at) {
      rawData.name = `[Disconnected] ${rawData.name}`;
    } */
    this.updateWith(rawData);
  }

  get currencyDetails() {
    return appInstance().$store.getters['app/currencies'].find(i => i.code === this.currency);
  }

  get currencySymbol() {
    return this.currencyDetails ? this.currencyDetails.symbol : '';
  }
}
